import React from "react";

import styles from "./PurchaseVerify.module.scss";
import PurchaseCard from "../../components/purchaseCard";

const PurchaseVerify = () => {
  return (
    <div className={styles.PurchaseVerify}>
      <PurchaseCard />
    </div>
  );
};

export default PurchaseVerify;
